// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__8bNqJ","image":"styles_image__Av1el"};